module.exports = __webpack_public_path__ + "static/img/blank-img.e73a611.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blank-img.jpeg
// module id = IS4m
// module chunks = 2